import {UPDATE_STUDENT} from "./../../routes";
import customAxios from "../../customAxios";
import {IUpdateStudent} from "../../../types/student.interface";
import utils from "../../../utils";

const updateService = async (formData: IUpdateStudent) => {
  try {
    return (
      await customAxios.put(UPDATE_STUDENT, {
        ...formData,
        province: formData.province?._id,
        gender: formData.gender?.value,
        grade: formData.grade?._id,
        field: formData.field?._id,
        city: formData.city?._id,
        timing: {
          friday: utils.convertServiceTiming.htmlToMongo(formData.timing?.friday),
          sunday: utils.convertServiceTiming.htmlToMongo(formData.timing?.sunday),
          monday: utils.convertServiceTiming.htmlToMongo(formData.timing?.monday),
          tuesday: utils.convertServiceTiming.htmlToMongo(formData.timing?.tuesday),
          thursday: utils.convertServiceTiming.htmlToMongo(formData.timing?.thursday),
          saturday: utils.convertServiceTiming.htmlToMongo(formData.timing?.saturday),
          wednesday: utils.convertServiceTiming.htmlToMongo(formData.timing?.wednesday),
        },
      })
    ).data;
  } catch (error: unknown) {
    console.error({UPDATE_STUDENT: error});
    return false;
  }
};

export default updateService;
